import { render, staticRenderFns } from "./AddSon.vue?vue&type=template&id=7e13210e&scoped=true&"
import script from "./AddSon.vue?vue&type=script&lang=js&"
export * from "./AddSon.vue?vue&type=script&lang=js&"
import style0 from "./AddSon.vue?vue&type=style&index=0&id=7e13210e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e13210e",
  null
  
)

export default component.exports